import React from 'react';
import { getReleasedProjects, getInProgressProjects } from '../data/projects';
import ProjectCard from './ProjectCard';

function ProjectSection() {
  const released = getReleasedProjects();
  const inProgress = getInProgressProjects();

  return (
    <section className="section has-text-centered" id="projects-con">
      <div className="container">
        <h2 className="title is-spaced is-size-2-desktop is-size-3-tablet is-size-3-mobile" id="main-title">
          Projects
        </h2>
        <div className="columns is-centered is-multiline">
          {released.map((project) => (
            <div key={project.slug} className="column is-5-desktop is-6-tablet">
              <ProjectCard project={project} />
            </div>
          ))}
        </div>

        {inProgress.length > 0 && (
          <div className="projects-in-progress">
            <h3 className="projects-in-progress-title">In progress</h3>
            <div className="columns is-centered is-multiline">
              {inProgress.map((project) => (
                <div key={project.slug} className="column is-5-desktop is-6-tablet">
                  <ProjectCard project={project} compact />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default ProjectSection;
